import { PARTAGE_FORM_FAILURE, PARTAGE_FORM_REQUEST, PARTAGE_FORM_SUCCESS } from "../Types";

const initialState = {
  loading: false,
  success: false,
  error: null,
  data: null,
};

const PartageFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case PARTAGE_FORM_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null,
      };

    case PARTAGE_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload,
        error: null,
      };

    case PARTAGE_FORM_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default PartageFormReducer;
